import http from '../utils/http'
import request from '../utils/request'

const apphttp = 'https://tzmap.tzyuansheng.com'
const geoserver = 'https://tzmap.tzyuansheng.com/geoserver/'
const lz='http://192.168.16.111:8080'

// https://tzmap.tzyuansheng.com/app/v1/loc/radius?longitude=121.38854563236237&latitude=28.94169509410858&rad=100

// 隧道的接口
export function getsdViewAPI(cql) {
  const query = `benm ilike '%${cql}%' or becd ilike '%${cql}%'`
  const queryencodeURI = encodeURIComponent(query)
  // console.log('queryencodeURI' + queryencodeURI)

  let feature_url = geoserver + 'wfs?request=GetFeature&version=1.1.0&typeName=fangjia:sdview&outputFormat=application/json'

  if (cql) {
    feature_url = feature_url + '&CQL_FILTER=' + queryencodeURI
  }

  console.log(feature_url)

  return http.get(feature_url, '')
}

// 桥梁的接口
export function getqlViewAPI(cql) {
  const query = `benm ilike '%${cql}%' or becd ilike '%${cql}%'`
  const queryencodeURI = encodeURIComponent(query)
  // console.log('queryencodeURI' + queryencodeURI)

  let feature_url = geoserver + 'wfs?request=GetFeature&version=1.1.0&typeName=fangjia:qlview&outputFormat=application/json'

  if (cql) {
    feature_url = feature_url + '&CQL_FILTER=' + queryencodeURI
  }

  console.log(feature_url)

  return http.get(feature_url, '')
}

// 桩号接口
export function getpViewAPI(lxbm, k1, k2) {
  console.log('k' + k1 + 'K2' + k2)
  const query = `lxbm ='${lxbm}' and zh >= ${k1} and zh <= ${k2}`
  const queryencodeURI = encodeURIComponent(query)

  let feature_url = geoserver + 'wfs?request=GetFeature&version=1.1.0&typeName=fangjia:pview&outputFormat=application/json&feature_count=1'

  feature_url = feature_url + '&CQL_FILTER=' + queryencodeURI

  return http.get(feature_url, '')
}

// 天地图的接口
export function gettdgeocodeAPI(lon, lat) {
  return http.get(`https://api.tianditu.gov.cn/geocoder?postStr={'lon':${lon},'lat':${lat},'ver':1}&type=geocode&tk=feafbea547a04e74ed0c22264c594ddf`, '')
}

// 附近桩号的接口
export function getradiusAPI(lon, lat) {
  return http.get(apphttp + `/app/v1/loc/radius?longitude=${lon}&latitude=${lat}&rad=100`, '')
}

// 用户登录
export function login(data) {
  return http.posts(apphttp + `/api/oauth/Login?client_id=admin&client_secret=123456&scope=all&grant_type=password`, data)
  // return request({
  //   url: apphttp + '/api/oauth/Login',
  //   method: 'post',
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   },
  //   data: data
  // })
}
// 筛选道路、区域类型
export function getRoadTypeAndSon(data) {
  return http.get(apphttp + `/api/example/Lx/infoList`, data)
}



// WEBPACK FOOTER //
// ./src/api/api.js